import Immutable from 'immutable';

export const GET_TENANTS = 'takeback/api/GET_TENANTS';
export const GET_TENANTS_SUCCESS = 'takeback/api/TENANTS_SUCCESS';
export const GET_TENANTS_FAILURE = 'takeback/api/TENANTS_FAILURE';

const initialState = Immutable.Map();

// Reducers
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case GET_TENANTS_SUCCESS:
        return state.mergeDeep(action.tenants.reduce((map, tenant) => {
            return map.set(tenant.get('name'), tenant);
        }, Immutable.Map()));
    default: return state;
    }
}

// Actions
export function getTenants(params = {}, options = {}) {
    return Object.assign({ type: GET_TENANTS, params }, options);
}

export function getTenantsSuccess(tenants) {
    return { type: GET_TENANTS_SUCCESS, tenants };
}

export function getTenantsFailure(error) {
    return { type: GET_TENANTS_FAILURE, error };
}
